__turbopack_context__.v({
  "button": "Button-module__LnOHOq__button",
  "buttonWrapper": "Button-module__LnOHOq__buttonWrapper",
});
